module.exports = __webpack_public_path__ + "img/bnt1.182a120b.png";